module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/assign.js
// module id = 256
// module chunks = 9 35 38 42 49 53 78 79 82 88 92 164 165 171 172